import { Phone, MessageCircle, ShieldCheck, Clock, Truck, ThumbsUp, Target, Heart } from "lucide-react";
import { COMPANY, SERVICES, waLink, bairrosImage, heroImage } from "@/data/site";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CTABanner } from "@/components/CTABanner";

export default function Sobre() {
  const values = [
    { icon: Clock, t: "Prontidão", d: "Plantão 24h, todos os dias do ano. Quando você precisa, estamos a caminho." },
    { icon: ShieldCheck, t: "Garantia", d: "Todo serviço executado tem garantia. Sua tranquilidade em primeiro lugar." },
    { icon: Target, t: "Transparência", d: "Orçamento claro antes de iniciar. Sem surpresas na hora de pagar." },
    { icon: Heart, t: "Respeito", d: "Profissionais uniformizados, educados e cuidadosos com o seu imóvel." },
  ];
  return (
    <>
      <SEO
        title="Sobre a Desentupidora Paulistana | +15 anos em São Paulo"
        description="Há mais de 15 anos, a Desentupidora Paulistana é referência em desentupimento 24h nos bairros nobres de São Paulo. Conheça nossos valores e compromisso."
        path="/sobre"
      />
      <section className="bg-brand-black text-white">
        <div className="max-w-7xl mx-auto container-px py-14">
          <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Sobre" }]} />
          <h1 className="font-display font-black text-4xl sm:text-5xl mt-4 mb-3">Sobre a Paulistana</h1>
          <p className="text-gray-300 max-w-2xl">Compromisso, excelência e prontidão de emergência — há mais de 15 anos cuidando das tubulações dos bairros nobres de São Paulo.</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto container-px py-16 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="section-label">Nossa história</span>
            <h2 className="font-display font-extrabold text-3xl text-brand-black mb-5">Uma empresa construída sobre a confiança</h2>
            <p className="text-gray-600 mb-4">A Desentupidora Paulistana nasceu para oferecer um serviço de desentupimento à altura das regiões mais exigentes de São Paulo. Em mais de 15 anos, atendemos milhares de famílias, condomínios e empresas com a mesma seriedade.</p>
            <p className="text-gray-600 mb-4">Investimos continuamente em equipamentos — máquinas rotativas e hidrojateamento de alta pressão — e em treinamento das equipes, garantindo soluções rápidas e duradouras, sem quebra-quebra.</p>
            <p className="text-gray-600">Nosso compromisso é simples: chegar rápido, resolver de verdade e tratar o seu imóvel com o respeito que ele merece.</p>
          </div>
          <div className="relative">
            <img src={heroImage} alt="Equipe da Desentupidora Paulistana" loading="lazy" className="rounded-xl w-full max-w-sm mx-auto object-cover shadow-lg" />
            <div className="absolute -bottom-5 left-3 bg-brand-red text-white rounded-lg px-5 py-4 shadow-xl">
              <span className="block font-display font-black text-3xl leading-none">+15</span>
              <span className="block text-xs font-bold uppercase tracking-wide mt-1">Anos de experiência</span>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-light">
        <div className="max-w-7xl mx-auto container-px py-16">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="section-label">No que acreditamos</span>
            <h2 className="font-display font-extrabold text-3xl text-brand-black">Nossos valores</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v, i) => (
              <div key={i} className="bg-white rounded-lg p-6 shadow-sm">
                <span className="grid place-items-center w-12 h-12 rounded-lg bg-brand-red mb-4"><v.icon className="w-6 h-6 text-white" /></span>
                <h3 className="font-display font-bold text-lg text-brand-black mb-2">{v.t}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
